import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./admin.css";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!email.trim() || !password) {
      setError("Email and password are required.");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch("/api/admin/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim().toLowerCase(), password }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.message || "Login failed.");
        return;
      }
      localStorage.setItem("adminToken",     data.token);
      localStorage.setItem("adminRole",      data.admin.admin_role);
      localStorage.setItem("adminFirstname", data.admin.firstname);
      localStorage.setItem("adminLastname",  data.admin.lastname);
      localStorage.setItem("adminEmail",     data.admin.email);
      navigate("/admin/dashboard", { replace: true });
    } catch {
      setError("Unable to connect to server. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="adm-login-page adm-root">
      <div className="adm-login-card">
        <div className="adm-login-logo">
          {/* Use same logo as main app if available */}
          <div style={{
            width: 52, height: 52, borderRadius: 12,
            background: "linear-gradient(135deg,#0f2747,#1f3f67)",
            display: "flex", alignItems: "center", justifyContent: "center",
            color: "#f06c24", fontWeight: 900, fontSize: "1.4rem", letterSpacing: "-.02em"
          }}>
            GB
          </div>
          <h1>GharBhada</h1>
          <span className="adm-login-portal-badge">Admin Portal</span>
        </div>

        <form className="adm-login-form" onSubmit={handleSubmit} noValidate>
          {error && <div className="adm-login-error">{error}</div>}

          <div className="adm-form-group">
            <label htmlFor="adm-email">Email address</label>
            <input
              id="adm-email"
              type="email"
              autoComplete="username"
              placeholder="admin@gharbhada.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
            />
          </div>

          <div className="adm-form-group">
            <label htmlFor="adm-password">Password</label>
            <input
              id="adm-password"
              type="password"
              autoComplete="current-password"
              placeholder="••••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
            />
          </div>

          <button className="adm-login-btn" type="submit" disabled={loading}>
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>

        <p style={{ textAlign: "center", marginTop: "1.25rem", fontSize: ".75rem", color: "#94a3b8" }}>
          Authorised personnel only. All activity is monitored and logged.
        </p>
      </div>
    </div>
  );
}
